import React from 'react';

import FaqPage from '../components/FaqPage';

const FAQ = () => (
  <FaqPage
    lang="ptbr"
    title="FAQ | Full Stack Aberto"
    seoDescription="Perguntas Frequentes"
  />
);

export default FAQ;
